import { useEffect, useState } from "react";
import CustomerProjectsLayout from "../layouts/CustomerProjectsLayout";

const CustomerProjects = () => {
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const path = window.location.pathname;

    const companyNameFromUrl = decodeURIComponent(path.split("/projects/")[1]);

    setCompanyName(companyNameFromUrl);
  }, []);

  return (
    <div className="p-8 bg-gray-100">
      <CustomerProjectsLayout name={companyName} />
    </div>
  );
};

export default CustomerProjects;
